const getStyle = (el, cssStyle) => {
    const re = /(-)(\w)/g;
    const ieStyle = cssStyle.replace(re, (m, p1, p2) => p2.toUpperCase());
    if (el.currentStyle) {
        // IE
        return el.currentStyle[ieStyle];
    }
    if (window.getComputedStyle) {
        // W3C
        return window.getComputedStyle(el, '').getPropertyValue(cssStyle);
    }
    return null;
};
export default getStyle;
